<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, useWidgetEmits } from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)

// if you need, you can override the title of course
const title = 'Progress Bars'

const items: {
  id: string
  name: string
  percentValue: number
  className: string
}[] = [
  {
    id: 'primary',
    name: 'Primary',
    percentValue: 51,
    className: 'dashboard-progress bg-primary-gradient content-primary',
  },
  {
    id: 'info',
    name: 'Info',
    percentValue: 63,
    className: 'dashboard-progress bg-info-gradient content-info',
  },
  {
    id: 'warning',
    name: 'Warning',
    percentValue: 74,
    className: 'dashboard-progress bg-warning-gradient content-warning',
  },
  {
    id: 'danger',
    name: 'Danger',
    percentValue: 35,
    className: 'dashboard-progress bg-danger-gradient content-danger',
  },
  {
    id: 'success',
    name: 'Success',
    percentValue: 97,
    className: 'dashboard-progress bg-success-gradient content-success',
  },
  {
    id: 'flat',
    name: 'Flat - no gradient',
    percentValue: 45,
    className: 'dashboard-progress bg-primary',
  },
]
</script>

<template>
  <DashboardWidgetBase v-bind="props" :title="title" v-on="emitHandlers">
    <div class="flex flex-col justify-between mt-1 gap-6">
      <div class="flex flex-col gap-2">
        <div v-for="item in items" key="{item.id}" class="flex flex-col">
          <span class="ml-1 font-semibold text-xs">{{ item.name }}</span>
          <div class="dashboard-progress-bar bg-cardchild flex items-center">
            <div :class="item.className" :style="`width: ${item.percentValue}%`"></div>
          </div>
        </div>
      </div>
      <div class="text-sm">~0.5% margin of error</div>
    </div>
  </DashboardWidgetBase>
</template>
